import React, { FC } from 'react';
import { Footer } from 'antd/lib/layout/layout';
import cl from '../LayoutPage.module.css';
export const FooterLayout: FC = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Footer className={cl.footerAsn}>© Astel IoT Djailay 2021 - {currentYear} </Footer>
    )
}